import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const FitWelcome = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [pid] = useState(location?.state?.pid )
  const [onBoardData] = useState(location.state.onBoardData)
  const [eligibilityResults] = useState(location.state.eligibilityResults)
  const[access, setAccess] = useState(-1)
  const navigate = useNavigate(); // Added navigate


  // Authentication check
  useEffect(() => {
    if (!pid) {
      navigate('/');
    } else {
      const body = { "username": pid, "scope": "participant" };
      const connectionString = "https://app.digitalwellnessnurse.com";

      fetch(`${connectionString}/api/portal/verify`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: "include",
        body: JSON.stringify(body),
      })
        .then((response) => {
          setAccess(response.status);
          return response.json();
        })
        .then((json) => {
          if (json.access !== 200) {
            navigate('/');
          }
        })
        .catch((error) => {
          console.error("Error verifying access:", error);
          navigate('/'); // Redirect on error
        });
    }
  }, [pid, navigate]); // Depend on pid and navigate


  useEffect(() => {

    if (access !== 200) return; // Only proceed if access is granted

    const fetchOnboardingData = async () => {
    console.log("Welcome")
    console.log(
        JSON.stringify({
            onBoardData:onBoardData,
            eligibilityResults:eligibilityResults
          })
      )


      try {
        const response = await fetch('https://app.digitalwellnessnurse.com/api/portal/fit/onboard', {   //https://app.digitalwellnessnurse.com  http://localhost:2001
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            onBoardData:onBoardData,
            eligibilityResults:eligibilityResults
          })
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch onboarding data: ${response.status}`);
        }

        const result = await response.json();
        console.log('Onboarding response:', result);

        setData(result);
      } catch (err) {
        console.error('Error fetching onboarding data:', err.message);
        setError('Failed to load onboarding data. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchOnboardingData();
  }, [access]); // Depend on access to run when it changes


  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>Welcome to FIT</h1>
      <p>Thank you for joining our study! Below are your credentials and assignments:</p>

      <div style={{ marginBottom: '20px' }}>
        <h2>Caregiver Credentials</h2>
        <p><strong>Username:</strong> {data.credentials.parentUsername}</p>
        <p><strong>Password:</strong> {data.credentials.parentPassword}</p>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h2>Child Credentials</h2>
        <p><strong>Username:</strong> {data.credentials.childUsername}</p>
        <p><strong>Password:</strong> {data.credentials.childPassword}</p>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h2>Assigned Information</h2>
        <p><strong>Healthcare Coach:</strong> {data.assignments.assignedHealthcareCoach.firstName+"  "+data.assignments.assignedHealthcareCoach.lastName}</p>
        <p><strong>Username:</strong> {data.assignments.assignedHealthcareCoach.pid}</p>
        <p><strong>Assigned ARM:</strong> {data.assignments.assignedArm}</p>
      </div>

      <div>
        <h2>Next Steps</h2>
        <p>You can access the app using the following link:</p>
        <a href="https://app.digitalwellnurse.com" target="_blank" rel="noopener noreferrer">
          app.digitalwellnurse.com
        </a>
      </div>
    </div>
  );
};

export default FitWelcome;
